import {
  ROUTE_FORGET_PASSWORD,
  ROUTE_LOGIN,
  ROUTE_RESET_PASSWORD,
} from "./auth.routes";
import LoginPage from "../../modules/auth/login.page";
import MissingStaffFieldsPage from "../../modules/dashboard/missing-staff-fields.page";
import { ROUTE_MISSING_STAFF_FIELDS } from "./private.routes";
import {
  ROUTE_DASHBOARD,
  ROUTE_MANAGE_DEPARTMENT,
  ROUTE_MANAGE_STAFF,
  ROUTE_STAFF_PROFILE,
  ROUTE_STAFF_DASHBOARD,
  ROUTE_STAFF_EXPORT,
  ROUTE_MANAGE_PROJECT,
  ROUTE_PROJECT_DASHBOARD,
  ROUTE_MILESTONES,
  ROUTE_MANAGE_BILLING_CYCLE,
  ROUTE_MANAGE_VENDOR,
  ROUTE_BILLING_SUMMARY,
  ROUTE_ALLOCATION_REPORT,
  ROUTE_REPORTS,
  ROUTE_REPORT_BUILDER,
  ROUTE_REPORT_DETAILS,
  ROUTE_MANAGE_ACCOUNT,
  ROUTE_MANAGE_SUB_DEPARTMENT,
  ROUTE_MANAGE_DEAL_STAGE,
  ROUTE_MANAGE_DEAL_SUB_STAGE,
  ROUTE_MANAGE_FOREX,
  ROUTE_MANAGE_SALES,
  ROUTE_SALES_DASHBOARD,
  ROUTE_SALES_WON,
  ROUTE_SALES_LOST,
  ROUTE_SALES_EXPORT,
  ROUTE_MANAGE_IT,
  ROUTE_IT_DASHBOARD,
  ROUTE_EXPORT_IT_ASSETS,
  ROUTE_CANDIDATE_SCREENING,
  ROUTE_RESUME_MASTER,
  ROUTE_SCREENING_RESULTS,
  // ROUTE_SCREENING_RULES,
  ROUTE_SCREENING_AI_CONFIG,
  ROUTE_MANAGE_USERS,
  ROUTE_MANAGE_ROLES,
  ROUTE_MANAGE_DOCUMENT_TYPE,
  ROUTE_MANAGE_DOCUMENT_SUB_TYPE,
  ROUTE_MANAGE_RELEASE,
  ROUTE_PROJECT_EXPORT,
  ROUTE_MILESTONE_EXPORT
} from "./private.routes";
import ManageStaffPage from "../../modules/staff/manage-staff.page";
import StaffProfilePage from "../../modules/staff/staff-profile.page";
import StaffDashboardPage from "../../modules/staff/staff-dashboard.page";
import ExportStaffPage from "../../modules/staff/export-staff.page";
import ManageDepartmentPage from "../../modules/department/manage-department.page";
import ManageProjectPage from "../../modules/project/manage-project.page";
import ExportProjectPage from "../../modules/project/export-project.page";
import ProjectDashboardPage from "../../modules/project/project-dashboard.page";
import ManageMilestonesPage from "../../modules/project/manage-milestones.page";
import ExportMilestonesPage from "../../modules/project/export-milestones.page";
import ManageBillingCyclePage from "../../modules/project/manage-billing-cycle.page";
import ManageVendorPage from "../../modules/vendor/manage-vendor.page";
import BillingCycleSummary from "../../modules/project/billing-summary.page";
import AllocationReportPage from "../../modules/project/allocation-report.page";
import ManageAccountsPage from "../../modules/accounts/manage-accounts.page";
import ManageSubDepartmentPage from "../../modules/department/manage-sub-department.page";
import StaffAssignmentSummaryComponent from "../../modules/project/components/staff-assignment-summary.component";
import ManageForexPage from "../../modules/forex/manage-forex.page";
import ManageSalesPage from "../../modules/sales/manage-sales.page";
import SalesDashboardPage from "../../modules/sales/sales-dashboard.page";
import ExportSalesPage from "../../modules/sales/export-sales.page";
import ManageItAssetsPage from "../../modules/it-assets/manage-it-assets.page";
import ExportItAssetsPage from "../../modules/it-assets/export-it-assets.page";
import ItDashboardPage from "../../modules/it-assets/it-dashboard.page";
import ManageDealStagesPage from "../../modules/sales/manage-deal-stages.page";
import ManageJobDescriptionPage from "../../modules/candidate-screening/manage-job-description.page";
import ResumeMasterPage from "../../modules/candidate-screening/resume-master.page";
import ScreeningResultsPage from "../../modules/candidate-screening/screening-results.page";
// import ManageScreeningRulesPage from "../../modules/candidate-screening/manage-screening-rules.page";
import AiConfigPage from "../../modules/candidate-screening/ai-config.page";
import ManageUsersPage from "../../modules/users/manage-users.page";
import ManageRolesPage from "../../modules/roles/manage-roles.page";
import ManageDocumentTypePage from "../../modules/document-type/manage-document-type.page";
import ManageDocumentSubTypePage from "../../modules/document-sub-type/manage-document-sub-type.page";
import DashboardPage from "../../modules/dashboard/dashboard.page";
import ReportBuilderPage from "../../modules/reports/report-builder.page";
import ManageReportsPage from "../../modules/reports/manage-reports.page";
import { allPermissions } from "../constants/constants";
import { ROUTE_MANAGE_EMAIL } from "./private.routes";
import ManageEmailPage from "../../modules/email/manage-email.page";
import ManageReleasePage from "../../modules/release-notes/admin/manage-release.page";



export const ROUTES_OPEN: any[] = [
  {
    name: "Login",
    route: ROUTE_LOGIN,
    component: <LoginPage />,
  },
  // {
  //   name: "Reset Pasword",
  //   route: ROUTE_RESET_PASSWORD,
  //   component: <ResetPasswordPage />,
  // },
  // {
  //   name: "Forget Password",
  //   route: ROUTE_FORGET_PASSWORD,
  //   component: <ForgotPasswordPage />,
  // },
];

export const ROUTES_PROTECTED: any[] = [
  {
    name: "Deal Stage", module: "DEAL_STAGE", route: ROUTE_MANAGE_DEAL_STAGE,
    permission: [allPermissions.VIEW_DEAL_STAGE], component: <ManageDealStagesPage key="deal-stage" />,
  },
  {
    name: "Deal Sub-Stage", module: "DEAL_SUB_STAGE", route: ROUTE_MANAGE_DEAL_SUB_STAGE,
    permission: [allPermissions.VIEW_DEAL_SUB_STAGE], component: <ManageDealStagesPage key="deal-sub-stage" subStage />,
  },
  {
    name: "Dashboard",
    module: "DASHBOARD",
    route: ROUTE_DASHBOARD,
    permission: [allPermissions.VIEW_DASHBOARD],
    component: <DashboardPage />,
  },
  {
    name: "Staff Dashboard",
    module: "STAFF",
    route: ROUTE_STAFF_DASHBOARD,
    permission: [allPermissions.VIEW_STAFF],
    component: <StaffDashboardPage />,
  },
  {
    name: "Staff",
    module: "STAFF",
    route: ROUTE_MANAGE_STAFF,
    permission: [allPermissions.VIEW_STAFF],
    component: <ManageStaffPage />,
  },
  {
    name: "Staff Profile",
    module: "STAFF",
    route: ROUTE_STAFF_PROFILE,
    permission: [allPermissions.VIEW_STAFF],
    component: <StaffProfilePage />,
  },
  {
    name: "Export Staff",
    module: "STAFF",
    route: ROUTE_STAFF_EXPORT,
    permission: [allPermissions.VIEW_STAFF],
    component: <ExportStaffPage />,
  },
  {
    name: "Missing Information", module: "STAFF", route: ROUTE_MISSING_STAFF_FIELDS,
    permission: [allPermissions.VIEW_STAFF], component: <MissingStaffFieldsPage />,
  },
  {
    name: "Department",
    module: "DEPARTMENT",
    route: ROUTE_MANAGE_DEPARTMENT,
    permission: [allPermissions.VIEW_DEPARTMENT],
    component: <ManageDepartmentPage />,
  },
  {
    name: "Sub Department",
    module: "SUB_DEPARTMENT",
    route: ROUTE_MANAGE_SUB_DEPARTMENT,
    permission: [allPermissions.VIEW_SUBDEPARTMENT],
    component: <ManageSubDepartmentPage />,
  },
  {
    name: "Project Dashboard",
    module: "PROJECT",
    route: ROUTE_PROJECT_DASHBOARD,
    permission: [allPermissions.VIEW_PROJECT],
    component: <ProjectDashboardPage />,
  },
  {
    name: "Project",
    module: "PROJECT",
    route: ROUTE_MANAGE_PROJECT,
    permission: [allPermissions.VIEW_PROJECT],
    component: <ManageProjectPage />,
  },
  {
    name: "Export Project",
    module: "PROJECT",
    route: ROUTE_PROJECT_EXPORT,
    permission: [allPermissions.VIEW_PROJECT],
    component: <ExportProjectPage />,
  },
  {
    name: "Milestones",
    module: "MILESTONES",
    route: ROUTE_MILESTONES,
    permission: [allPermissions.MILESTONE_VIEW],
    component: <ManageMilestonesPage />,
  },
  {
    name: "Export Milestones",
    module: "MILESTONES",
    route: ROUTE_MILESTONE_EXPORT,
    permission: [allPermissions.MILESTONE_VIEW],
    component: <ExportMilestonesPage />,
  },
  {
    name: "Billing Cycle",
    module: "BILLING_CYCLE",
    route: ROUTE_MANAGE_BILLING_CYCLE,
    permission: [allPermissions.VIEW_BILLING_SUMMARY],
    component: <ManageBillingCyclePage />,
  },
  {
    name: "Billing Summary",
    module: "BILLING_CYCLE",
    route: ROUTE_BILLING_SUMMARY,
    permission: [allPermissions.VIEW_BILLING_SUMMARY],
    // component: <BillingCycleSummary />,
    component: <StaffAssignmentSummaryComponent />
  },
  {
    name: "Allocation Report",
    module: "PROJECT",
    route: ROUTE_ALLOCATION_REPORT,
    component: <AllocationReportPage />,
  },
  {
    name: "Manage Reports",
    module: "REPORTS",
    route: ROUTE_REPORTS,
    permission: [allPermissions.VIEW_REPORT],
    component: <ManageReportsPage />,
  },
  {
    name: "Create Report",
    module: "REPORTS",
    route: ROUTE_REPORT_BUILDER,
    permission: [allPermissions.VIEW_REPORT],
    component: <ReportBuilderPage />,
  },
  {
    name: "Report Details",
    module: "REPORTS",
    route: ROUTE_REPORT_DETAILS,
    permission: [allPermissions.VIEW_REPORT],
    component: <ReportBuilderPage />,
  },
  {
    name: "Vendor",
    module: "VENDOR",
    route: ROUTE_MANAGE_VENDOR,
    permission: [allPermissions.VIEW_VENDOR],
    component: <ManageVendorPage />,
  },
  {
    name: "Accounts",
    module: "ACCOUNTS",
    route: ROUTE_MANAGE_ACCOUNT,
    permission: [allPermissions.VIEW_ACCOUNT],
    component: <ManageAccountsPage />,
  },
  {
    name: "Forex",
    module: "FOREX",
    route: ROUTE_MANAGE_FOREX,
    permission: [allPermissions.VIEW_FOREX],
    component: <ManageForexPage />,
  },
  {
    name: "Sales Dashboard",
    module: "SALES",
    route: ROUTE_SALES_DASHBOARD,
    permission: [allPermissions.VIEW_SALES],
    component: <SalesDashboardPage />,
  },
  {
    name: "Pipeline",
    module: "SALES",
    route: ROUTE_MANAGE_SALES,
    permission: [allPermissions.VIEW_SALES],
    component: <ManageSalesPage key="pipeline" />,
  },
  {
    name: "Export Sales",
    module: "SALES",
    route: ROUTE_SALES_EXPORT,
    permission: [allPermissions.VIEW_SALES],
    component: <ExportSalesPage />,
  },
  { name: "Won", module: "SALES", route: ROUTE_SALES_WON, permission: [allPermissions.VIEW_SALES], component: <ManageSalesPage key="won" workflowStatus="WON" /> },
  { name: "Lost", module: "SALES", route: ROUTE_SALES_LOST, permission: [allPermissions.VIEW_SALES], component: <ManageSalesPage key="lost" workflowStatus="LOST" /> },
  {
    name: "IT Dashboard",
    module: "IT_ASSET",
    route: ROUTE_IT_DASHBOARD,
    permission: [allPermissions.VIEW_IT_ASSET],
    component: <ItDashboardPage />,
  },
  {
    name: "Manage IT",
    module: "IT_ASSET",
    route: ROUTE_MANAGE_IT,
    permission: [allPermissions.VIEW_IT_ASSET],
    component: <ManageItAssetsPage />,
  },
  {
    name: "Export IT Assets",
    module: "IT_ASSET",
    route: ROUTE_EXPORT_IT_ASSETS,
    permission: [allPermissions.VIEW_IT_ASSET],
    component: <ExportItAssetsPage />,
  },
  {
    name: "Candidate Screening",
    module: "CANDIDATE_SCREENING",
    route: ROUTE_CANDIDATE_SCREENING,
    permission: [allPermissions.VIEW_JD_MASTER],
    component: <ManageJobDescriptionPage />,
  },
  {
    name: "Resume Master",
    module: "CANDIDATE_SCREENING",
    route: ROUTE_RESUME_MASTER,
    permission: [allPermissions.VIEW_RESUME_MASTER],
    component: <ResumeMasterPage />,
  },
  {
    name: "Screening Results",
    module: "CANDIDATE_SCREENING",
    route: `${ROUTE_SCREENING_RESULTS}/:jobDescriptionId`,
    permission: [allPermissions.JD_MASTER_RANK],
    component: <ScreeningResultsPage />,
  },
  // {
  //   name: "Screening Rules",
  //   module: "CANDIDATE_SCREENING",
  //   route: ROUTE_SCREENING_RULES,
  //   component: <ManageScreeningRulesPage />,
  // },
  {
    name: "AI Configuration",
    module: "CANDIDATE_SCREENING",
    route: ROUTE_SCREENING_AI_CONFIG,
    permission: [allPermissions.AICONFIG_VIEW],
    component: <AiConfigPage />,
  },
  {
    name: "Users",
    module: "USERS",
    route: ROUTE_MANAGE_USERS,
    permission: [allPermissions.VIEW_USER],
    component: <ManageUsersPage />,
  },
  {
    name: "Roles",
    module: "ROLES",
    route: ROUTE_MANAGE_ROLES,
    permission: [allPermissions.VIEW_ROLE],
    component: <ManageRolesPage />,
  },
  {
    name: "Email",
    module: "EMAIL",
    route: ROUTE_MANAGE_EMAIL,
    permission: [allPermissions.VIEW_EMAIL],
    component: <ManageEmailPage />,
  },
  {
    name: "Document Type",
    module: "DOCUMENT_MANAGEMENT",
    route: ROUTE_MANAGE_DOCUMENT_TYPE,
    permission: [allPermissions.VIEW_DOCUMENT_TYPE],
    component: <ManageDocumentTypePage />,
  },
  {
    name: "Document Sub Type",
    module: "DOCUMENT_MANAGEMENT",
    route: ROUTE_MANAGE_DOCUMENT_SUB_TYPE,
    permission: [allPermissions.VIEW_DOCUMENT_SUB_TYPE],
    component: <ManageDocumentSubTypePage />,
  },
  {
    name: "Release Management",
    module: "RELEASE_MANAGEMENT",
    route: ROUTE_MANAGE_RELEASE,
    permission: [allPermissions.VIEW_RELEASE],
    component: <ManageReleasePage />,
  },
];
